export const baseURL = "https://backend.electrosoft-appointmentplus.com/"  // "https://backend.contentreel.io/"; 
export const appName = "Appointmentplus";
export const loginFooter = ".electrosoft-appointmentplus.com" //NOTE DO NOT FORGET TO ADD . OR - FOR THE URL
export const navBar = ".electrosoft-appointmentplus.com"  //NOTE DO NOT FORGET TO ADD . OR - FOR THE URL
